import React from "react";
import "./AboutHome.css";
function AboutHome() {
  return (
    <div className="aboutHome">
      <h1>ABOUT THE</h1>
      <h1>COMMUNITY</h1>
      <p>
        This is a online community for students like you, we are hard at work to
        put this thing together ,the main thing sites aims at is building
        network of students so that you get to know about more people in your
        field,ask doubts, stay in sync with college&studies, following your
        passion, collaborating etc, A community can provide you an environment
        ,Feel free to ask your doubts and also answer others ,stay in loop with
        college events and updates , Notes and practicals etc , A community
        provides you with encouraging environment to follow and pursue things
        you desire
      </p>
    </div>
  );
}

export default AboutHome;
